import http from "../http/http-config";
import { SearchPersonResponse } from "../models/searchPersonResponse";

export default new class SearchPersonService {
    GetSearchPersonData(IdentificationNumber, IdentificationTypeCode, Flag = true): Promise<SearchPersonResponse> {
        return http.get<SearchPersonResponse>("SearchPerson", {
            params: {
                IdentificationNumber,
                IdentificationTypeCode,
                Flag
            }
        }).then(response => response.data);
    }

    SetPerson(lastName, firstName): Promise<SearchPersonResponse> {
        return http.get<SearchPersonResponse>("SearchPerson/SetPerson", {
            params: {
                lastName,
                firstName
            }
        }).then(response => response.data);
    }

    SetCustomPerson(sessionKey, lastName, firstName): Promise<SearchPersonResponse> {
        return http.get<SearchPersonResponse>("SearchPerson/SetCustomPerson", {
            params: {
                sessionKey,
                lastName,
                firstName
            }
        }).then(response => response.data);
    }
}